export default "__VITE_ASSET___MIjvMsC__"